import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import { ColorProps } from 'styleguide-v2/src/utils/colors';

export const useStyles = makeStyles<Theme, ColorProps>({
  smallSize: {
    width: '17px',
    height: '17px',

    '&&.svg': {
      width: '20px',
      height: '20px',
    },
  },
  mediumSize: {
    width: '25px',
    height: '25px',
    '&&.svg': {
      width: '30px',
      height: '30px',
    },
  },
  largeSize: {
    width: '32px',
    height: '32px',
    '&&.svg': {
      width: '36px',
      height: '36px',
    },
  },
  icon: {
    '&': {
      color: ({ color }: ColorProps) => color,
    },
    '& path': {
      color: ({ color }: ColorProps) => color,
      stroke: ({ color }: ColorProps) => color,
    },
  },
});
